"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfirmLocale = exports.changeConfirmLocale = void 0;
var tslib_1 = require("tslib");
var runtimeLocale = tslib_1.__assign({}, {
    okText: '确定',
    cancelText: '取消',
    justOkText: '确定',
});
function changeConfirmLocale(newLocale) {
    if (newLocale) {
        runtimeLocale = tslib_1.__assign(tslib_1.__assign({}, runtimeLocale), newLocale);
    }
    else {
        runtimeLocale = tslib_1.__assign({}, {
            okText: '确定',
            cancelText: '取消',
            justOkText: '确定',
        });
    }
}
exports.changeConfirmLocale = changeConfirmLocale;
function getConfirmLocale() {
    return runtimeLocale;
}
exports.getConfirmLocale = getConfirmLocale;
//# sourceMappingURL=locale.js.map